import React, { useState } from "react";
import {
  Avatar,
  Badge,
} from "@mui/material";
import EditIcon from "../../components/Icons/EditIcon";
import { Link } from "react-router-dom";
import ApplicantOfferTabs from "../../components/Dashboard/Offer/ApplicantOfferTabs";
import ApplicantFileAttentionTableRow from "../../components/Dashboard/TableRows/ApplicantFileAttentionTableRow";


function CandidateDashboard() {
  const [showFileNeedingAttentionTable, setShowFileNeedingAttentionTable] =
    useState(false);

  const toggleFileNeedingAttentionTable = () => {
    setShowFileNeedingAttentionTable(!showFileNeedingAttentionTable);
  };
  return (
    <main className="">
      <div className="">
        <section className=" bg-white p-4 rounded shadow-sm">
          <div className="flex flex-col md:flex-row gap-8 items-start w-full ">
            <div>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={<EditIcon />}
                style={{
                  cursor: "pointer",
                }}
              >
                <Avatar
                  alt="Remy Sharp"
                  src="https://i.pravatar.cc/300"
                  sx={{ width: 150, height: 150, border: "1px solid #1E87FF" }}
                />
              </Badge>
            </div>
            <div className="flex-grow pl-[48px] pr-[31px]">
              <div className="flex justify-between mb-[24px]">
                <p className="text-xl font-bold ">Cameron Williamson</p>
              </div>
              <section className="flex flex-col md:flex-row  justify-between flex-grow w-full">
                <div className="w-[25%]">
                  <div className="mb-2">
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Discipline
                    </p>
                    <p className="text-[14px] font-[400]">Registered Nurse</p>
                  </div>
                  <div>
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Status
                    </p>
                    <p className=" text-[#32D583] text-[14px] font-[400]">
                      Active
                    </p>
                  </div>
                </div>

                <div className="w-[25%]">
                  <div className="mb-2">
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Date of hire
                    </p>
                    <p className=" text-[14px] font-[400]">22-05-2023</p>
                  </div>
                  <div>
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Birthday
                    </p>
                    <p className=" text-[14px] font-[400]">12-04-1983</p>
                  </div>
                </div>

                <div className="w-[25%]">
                  <div className="mb-2">
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Type of employment
                    </p>
                    <p className="text-[14px] font-[400]">22-05-2023</p>
                  </div>
                  <div>
                    <p className="text-[#98A2B3]  text-[12px] font-[500]">
                      Termination date
                    </p>
                    <p className="text-[14px] font-[400]">-</p>
                  </div>
                </div>

                <div className="w-[25%]">
                  <div className="mb-2">
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Rates
                    </p>
                    <p className="text-[14px] font-[400]">Soc: $30 per hour</p>
                  </div>
                  <div>
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Address
                    </p>
                    <p className=" text-[14px] font-[400]">
                      3891 Ranchview Dr. Richardson, California 62639
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="mt-[1.5rem]">
            <hr />
          </div>

          <div className="flex justify-between mt-[2.69rem]">
            <div className="flex gap-4">
              <span className="text-[#29272] font-[700] text-[0.875rem]">
                Files needing attention (3){" "}
              </span>
              {showFileNeedingAttentionTable ? (
                <svg
                  onClick={toggleFileNeedingAttentionTable}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="cursor-pointer"
                >
                  <path
                    d="M17.9197 15.8203H11.6897H6.07975C5.11975 15.8203 4.63975 14.6603 5.31975 13.9803L10.4997 8.80031C11.3297 7.97031 12.6797 7.97031 13.5097 8.80031L15.4797 10.7703L18.6897 13.9803C19.3597 14.6603 18.8797 15.8203 17.9197 15.8203Z"
                    fill="#425466"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="cursor-pointer"
                  onClick={toggleFileNeedingAttentionTable}
                >
                  <path
                    d="M17.9197 8.17969H11.6897H6.07975C5.11975 8.17969 4.63975 9.33969 5.31975 10.0197L10.4997 15.1997C11.3297 16.0297 12.6797 16.0297 13.5097 15.1997L15.4797 13.2297L18.6897 10.0197C19.3597 9.33969 18.8797 8.17969 17.9197 8.17969Z"
                    fill="#425466"
                  />
                </svg>
              )}
            </div>
            <Link to={"/candidate/dashboard/need-attention"}>
              <div className="text-[#1E87FF] font-[700] text-[0.875rem]">
                View all
              </div>
            </Link>
          </div>
        </section>
        {showFileNeedingAttentionTable && <ApplicantFileAttentionTableRow />}
      </div>
      <section>
        <ApplicantOfferTabs />
      </section>
    </main>
  );
}

export default CandidateDashboard;
